module.exports = __webpack_public_path__ + "static/media/ec.72441e01.svg";